export const sponsorTypesInitialState = {
  types: null,
  isLoading: true,
}
